function setEqualHeight() {
    const leftColumn = document.querySelector('.two-col-scroll-1__col--left');
    const rightColumn = document.querySelector('.two-col-scroll-1__col--right');
    
    if (leftColumn && rightColumn) {
      // Reset the right column's height in case it was set previously,
      // ensuring we recalc the height based on the left column's current dimensions.
      rightColumn.style.height = 'auto';
      const leftHeight = leftColumn.offsetHeight;
      rightColumn.style.height = leftHeight + 'px';
    }
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    // Set equal heights after the initial page load
    setEqualHeight();
    
    // Update equal heights when the window is resized
    window.addEventListener('resize', setEqualHeight);
  });
  